export default "__VITE_ASSET__DyJh9iva__"